// Real-world case studies — concrete past projects with story, scope, outcome
// Each one is shown as a rich card with images, key facts and a customer quote

export const CASE_STUDIES = {
  de: [
    {
      id: "cs1",
      slug: "umzug-2zimmer-eimsbuettel",
      service: "umzug",
      service_label: "Umzug",
      title: "2-Zimmer-Umzug in Eimsbüttel — same day inkl. Endreinigung",
      summary: "Familie K. brauchte am Freitagabend Hilfe für einen Umzug am Samstag mit Kaution-Übergabe am Montag. Wir haben Möbeltransport, Entrümpelung der alten Wohnung und besenreine Endreinigung in einem Tag erledigt.",
      stats: { label1: "Dauer",   value1: "6 Std.",  label2: "Wohnfläche", value2: "62 m²",  label3: "Teamgröße", value3: "3 Personen" },
      price_eur: 1290,
      location: "Hamburg-Eimsbüttel",
      services_included: ["Möbeltransport", "Verpackung", "Entrümpelung Keller", "Endreinigung"],
      challenge: "Sehr kurzfristig (24 Std. Vorlauf), 4. Stock ohne Aufzug, Übergabe am Montag — Kaution musste gesichert werden.",
      solution: "Wir haben drei Teams parallel arbeiten lassen: zwei beim Tragen/Packen, eines bei der Endreinigung. Möbel-Tetris im Sprinter sorgte für eine einzige Fahrt statt zwei.",
      outcome: "Übergabe pünktlich am Montag um 10:00, Kaution wurde komplett zurückerstattet. Familie K. hat sich den nervlichen Stress eines Wochenend-Solo-Umzugs erspart und konnte direkt in die neue Wohnung einziehen.",
      quote: "„Wir hätten es alleine nie geschafft. Drei Profis, ein Tag, alles erledigt — sogar die Endreinigung. Wir empfehlen Talkani allen unseren Freunden in Hamburg.\"",
      quote_author: "Familie K., Eimsbüttel",
      image: "/generated/case_umzug_eimsbuettel.png",
      tag: "Express-Auftrag"
    },
    {
      id: "cs2",
      slug: "regenrinne-doppelhaus-volksdorf",
      service: "regenrinne_reinigung",
      service_label: "Regenrinnen-Reinigung",
      title: "Verstopfte Dachrinne am Doppelhaus — Kameradokumentation inklusive",
      summary: "Nach drei Wochen Dauerregen hatte der Kunde Wasserschaden an der Fassade. Unsere Rohrkamera identifizierte sofort einen Vogelnest-Stau im Fallrohr.",
      stats: { label1: "Dauer", value1: "2,5 Std.", label2: "Höhe", value2: "9 m", label3: "Kamera-Doku", value3: "Vollständig" },
      price_eur: 389,
      location: "Hamburg-Volksdorf",
      services_included: ["Dachrinnen-Reinigung", "Rohrkamera-Inspektion", "Fallrohr-Spülung", "Video-Dokumentation"],
      challenge: "Wasser lief seit Wochen über die Fassade. Versicherung verlangte Beleg, dass die Ursache fachgerecht beseitigt wurde.",
      solution: "Komplette Reinigung mit Hochdruckspülung, anschließend 4K-Inspektion mit der Rohrkamera. Video- und Foto-Bericht für die Versicherung.",
      outcome: "Versicherung akzeptierte den Bericht ohne Rückfragen. Folgeschaden an Putz und Fassade wurde voll reguliert — der Kunde musste keinen Cent aus eigener Tasche zahlen.",
      quote: "„Profis mit dem richtigen Werkzeug. Die Video-Doku war Gold wert — die Versicherung hat sofort gezahlt.\"",
      quote_author: "Herr S., Volksdorf",
      image: "/generated/case_regenrinne_volksdorf.png",
      tag: "Mit Video-Doku"
    },
    {
      id: "cs3",
      slug: "buero-reinigung-altona-monatlich",
      service: "reinigung",
      service_label: "Büroreinigung",
      title: "Monatliche Büroreinigung für Agentur in Altona",
      summary: "Eine Hamburger Digital-Agentur (12 Mitarbeitende) suchte einen Reinigungspartner für regelmäßige Wartung — Mo/Mi/Fr, je 2 Stunden, vor Bürobeginn.",
      stats: { label1: "Frequenz", value1: "3×/Woche", label2: "Dauer", value2: "2 Std.", label3: "Laufzeit", value3: "ab 6 Monaten" },
      price_eur: 690,
      price_unit: "/ Monat",
      location: "Hamburg-Altona",
      services_included: ["Büroreinigung", "Sanitärreinigung", "Müllentsorgung", "Glas- & Spiegelreinigung", "Küchenzeile"],
      challenge: "Reinigung musste vor 9:00 morgens fertig sein, Schlüsselzugang erforderlich, hoher Anspruch an Sauberkeit (Kundenmeetings ab 10:00).",
      solution: "Fest zugewiesenes 2er-Team, eigener Schlüssel mit Schlüsseldienst-Protokoll, Checkliste pro Einsatz wird per Foto bestätigt.",
      outcome: "Seit 14 Monaten Festkunde, 0 Beschwerden, monatliche Rechnung mit ausgewiesener MwSt., voll absetzbar als Betriebsausgabe.",
      quote: "„Wir vergessen oft, dass sie da waren — und das ist genau das Kompliment, das eine Reinigung verdient.\"",
      quote_author: "Geschäftsführer, Digital-Agentur Altona",
      image: "/generated/case_office_altona.png",
      tag: "Festvertrag"
    },
    {
      id: "cs4",
      slug: "autoteile-lkq-pv-hamburg",
      service: "autoteile",
      service_label: "Autoteile-Logistik",
      title: "Autoteile-Distribution für LKQ & PV Automotive — 300+ Lieferungen im Monat",
      summary: "Für Autoteile-Distributoren fahren wir täglich an Kfz-Werkstätten in Hamburg und Norddeutschland. Ersatzteile für laufende Reparaturen müssen in unter 60 Minuten in der Werkstatt sein — sonst steht ein Kunde ohne Auto da.",
      stats: { label1: "Lieferungen", value1: "300+/Monat", label2: "Express-Zeit", value2: "≤ 45 Min.", label3: "Werkstätten", value3: "6 aktive Kunden" },
      price_eur: null,
      price_unit: "Vertragspreis",
      location: "Hamburg + Metropolregion",
      services_included: ["Werkstatt-Belieferung", "Express-Zustellung", "Foto-Übergabe", "GPS-Nachweis", "Sammelrechnung"],
      challenge: "Werkstätten reservieren Reparaturplätze im 30-Minuten-Takt. Kommt das falsche Teil oder zu spät, bricht der Zeitplan zusammen und mehrere Kunden warten.",
      solution: "Feste Vormittags- und Nachmittagstouren mit fixen Slots pro Werkstatt. Zusätzlich Express-Fahrer auf Abruf für Notfälle. Jede Übergabe wird mit Foto + GPS-Zeitstempel dokumentiert.",
      outcome: "In 12 Monaten Zusammenarbeit: 100% Foto-Übergabe-Nachweis, Ø 42 Min. Express-Zeit von Bestellung bis Werkstatt-Übergabe, monatliche Sammelrechnung — kompatibel mit DATEV-Buchhaltung der Distributoren.",
      quote: "„Talkani ist praktisch unsere verlängerte Logistik-Abteilung. Wenn es brennt, sind sie da — mit Nachweis.\"",
      quote_author: "Logistik-Leitung, Autoteile-Distributor Hamburg",
      image: "/generated/autoteile_handover.png",
      tag: "B2B · Tagesgeschäft"
    },
    {
      id: "cs5",
      slug: "escooter-nachtservice-tier-dott",
      service: "escooter_service",
      service_label: "E-Scooter Nachtservice",
      title: "E-Scooter Nachtservice für TIER & Dott — bis zu 400 Fahrzeuge pro Nacht",
      summary: "Für Sharing-Anbieter übernehmen wir den nächtlichen Batterie- und Verteilungsdienst: einsammeln, laden, umverteilen — damit die Flotte morgens einsatzbereit in den Hotspot-Zonen steht.",
      stats: { label1: "Scooter/Nacht", value1: "250–400", label2: "Nachtschicht", value2: "22:00–06:00", label3: "Zonen", value3: "4 Bezirke" },
      price_eur: null,
      price_unit: "Vertragspreis",
      location: "Altona · Eimsbüttel · Innenstadt · HafenCity",
      services_included: ["Einsammeln defekter Scooter", "Batterie-Austausch", "Reinigung & Prüfung", "Verteilung in Hotspot-Zonen", "Inventur-Reports"],
      challenge: "Nutzer erwarten morgens ab 07:00 verfügbare Scooter in Innenstadt, Bahnhöfen und Uni-Vierteln. Nachts sind die Fahrzeuge oft in Wohngebieten verstreut — ohne Umverteilung schrumpft die Verfügbarkeit um bis zu 60%.",
      solution: "Fünf Sprinter im Nachteinsatz mit Live-App-Anbindung: automatische Route über niedrigste Batterien zuerst, Sammelpunkt an Ladelager, morgendliche Verteilung nach Nachfrage-Heatmap des Betreibers.",
      outcome: "Ø 98% der Flotte morgens um 07:00 einsatzbereit in den Zielzonen. Batterie-Ausfälle unter 1%. Ausbau-Option auf Bremen und Kiel in Planung.",
      quote: "„Zuverlässiger Ops-Partner. Nachts sehen wir sie nicht — morgens sehen wir das Ergebnis in der App.\"",
      quote_author: "Fleet Operations Manager, E-Scooter Sharing DE",
      image: "/generated/escooter.png",
      tag: "B2B · Nachtschicht"
    }
  ],

  en: [
    {
      id: "cs1",
      slug: "2room-move-eimsbuettel",
      service: "umzug",
      service_label: "Moving",
      title: "2-room move in Eimsbüttel — same day incl. final cleaning",
      summary: "Family K. needed help on Friday night for a Saturday move, with the keys handover (deposit on the line) due Monday. We handled furniture transport, junk removal and broom-clean final cleaning all in one day.",
      stats: { label1: "Duration", value1: "6 hrs", label2: "Floor area", value2: "62 m²", label3: "Team", value3: "3 people" },
      price_eur: 1290,
      location: "Hamburg-Eimsbüttel",
      services_included: ["Furniture transport", "Packing", "Cellar clearance", "Final cleaning"],
      challenge: "Very short notice (24h lead), 4th floor no elevator, key handover on Monday with deposit at stake.",
      solution: "We ran three teams in parallel: two on carrying/packing, one on cleaning. Furniture Tetris in the sprinter meant one trip instead of two.",
      outcome: "Keys handed back on time Monday 10:00, full deposit returned. Family K. avoided the stress of a solo weekend move and could focus on settling into the new flat.",
      quote: "\"We never could have done it alone. Three pros, one day, everything done — even the final cleaning. We recommend Talkani to all our Hamburg friends.\"",
      quote_author: "Family K., Eimsbüttel",
      image: "/generated/case_umzug_eimsbuettel.png",
      tag: "Express job"
    },
    {
      id: "cs2",
      slug: "gutter-cleaning-volksdorf",
      service: "regenrinne_reinigung",
      service_label: "Gutter cleaning",
      title: "Blocked roof gutter on duplex — camera documentation included",
      summary: "After three weeks of continuous rain, the customer had water damage to the facade. Our pipe camera immediately identified a bird's-nest blockage in the downpipe.",
      stats: { label1: "Duration", value1: "2.5 hrs", label2: "Height", value2: "9 m", label3: "Camera doc", value3: "Complete" },
      price_eur: 389,
      location: "Hamburg-Volksdorf",
      services_included: ["Gutter cleaning", "Pipe camera inspection", "Downpipe flush", "Video documentation"],
      challenge: "Water had been running down the facade for weeks. Insurance required proof that the cause was professionally removed.",
      solution: "Complete cleaning with high-pressure flush, then 4K inspection with the pipe camera. Video and photo report for insurance.",
      outcome: "Insurance accepted the report without follow-up. Subsequent damage to plaster and facade was fully reimbursed — the customer paid nothing out of pocket.",
      quote: "\"Pros with the right tools. The video doc was worth its weight in gold — insurance paid immediately.\"",
      quote_author: "Mr. S., Volksdorf",
      image: "/generated/case_regenrinne_volksdorf.png",
      tag: "With video doc"
    },
    {
      id: "cs3",
      slug: "office-cleaning-altona-monthly",
      service: "reinigung",
      service_label: "Office cleaning",
      title: "Monthly office cleaning for an agency in Altona",
      summary: "A Hamburg digital agency (12 staff) needed a cleaning partner for regular maintenance — Mon/Wed/Fri, 2 hours each, before office hours.",
      stats: { label1: "Frequency", value1: "3×/week", label2: "Duration", value2: "2 hrs", label3: "Term", value3: "14 months+" },
      price_eur: 690,
      price_unit: "/ month",
      location: "Hamburg-Altona",
      services_included: ["Office cleaning", "Sanitary cleaning", "Waste disposal", "Glass & mirror cleaning", "Kitchenette"],
      challenge: "Cleaning had to be done before 9 AM, key access required, high cleanliness standard (client meetings from 10 AM).",
      solution: "Permanently assigned 2-person team, dedicated key with key-service protocol, per-visit checklist confirmed by photo.",
      outcome: "Regular customer for 14 months, zero complaints, monthly invoice with VAT — fully deductible as business expense.",
      quote: "\"We often forget they were here — and that's exactly the compliment a cleaning service deserves.\"",
      quote_author: "Managing director, Digital agency Altona",
      image: "/generated/case_office_altona.png",
      tag: "Long-term contract"
    },
    {
      id: "cs4",
      slug: "auto-parts-lkq-pv-hamburg",
      service: "autoteile",
      service_label: "Auto-parts logistics",
      title: "Auto-parts distribution for LKQ & PV Automotive — 300+ deliveries per month",
      summary: "For automotive-parts distributors we run daily deliveries to workshops across Hamburg and Northern Germany. Spare parts for active repairs must be at the workshop in under 60 minutes — otherwise a customer is left without their car.",
      stats: { label1: "Deliveries", value1: "300+/mo", label2: "Express time", value2: "≤ 45 min", label3: "Workshops", value3: "6 active clients" },
      price_eur: null,
      price_unit: "Contract pricing",
      location: "Hamburg + metro area",
      services_included: ["Workshop delivery", "Express dispatch", "Photo handover", "GPS proof", "Consolidated invoicing"],
      challenge: "Workshops reserve repair bays in 30-minute slots. If the wrong part arrives — or arrives late — the schedule collapses and several customers wait.",
      solution: "Fixed morning and afternoon routes with dedicated slots per workshop, plus an on-call express driver for emergencies. Every handover is documented with photo + GPS timestamp.",
      outcome: "12 months in: 100% photo-handover proof, avg. 42 min from order to workshop handover, single monthly invoice — DATEV-compatible for the distributors' accounting.",
      quote: "\"Talkani is effectively our extended logistics team. When it burns, they're there — with proof.\"",
      quote_author: "Head of logistics, Auto-parts distributor Hamburg",
      image: "/generated/autoteile_handover.png",
      tag: "B2B · Daily ops"
    },
    {
      id: "cs5",
      slug: "escooter-night-service-tier-dott",
      service: "escooter_service",
      service_label: "E-Scooter night service",
      title: "E-scooter night service for TIER & Dott — up to 400 vehicles per night",
      summary: "For shared-mobility operators we run the night battery + redistribution service: pick up, charge, redistribute — so the fleet is ready for riders in hotspot zones by morning.",
      stats: { label1: "Scooters/night", value1: "250–400", label2: "Night shift", value2: "22:00–06:00", label3: "Zones", value3: "4 districts" },
      price_eur: null,
      price_unit: "Contract pricing",
      location: "Altona · Eimsbüttel · City · HafenCity",
      services_included: ["Defective scooter pickup", "Battery swap", "Cleaning & QC", "Redistribution to hotspots", "Inventory reports"],
      challenge: "Riders expect available scooters from 07:00 in the city centre, stations and university areas. Overnight, vehicles scatter into residential zones — without redistribution, availability drops by up to 60%.",
      solution: "Five sprinters running overnight with live-app integration: automated routes prioritise lowest batteries first, collect to charging depot, morning redistribution following the operator's demand heatmap.",
      outcome: "Avg. 98% of fleet ready to ride at 07:00 in target zones. Battery failures under 1%. Expansion to Bremen and Kiel in planning.",
      quote: "\"Reliable ops partner. We don't see them at night — we see the result in the app in the morning.\"",
      quote_author: "Fleet Operations Manager, E-scooter sharing DE",
      image: "/generated/escooter.png",
      tag: "B2B · Night shift"
    }
  ],

  ar: [
    {
      id: "cs1",
      slug: "naql-shaqqa-eimsbuettel",
      service: "umzug",
      service_label: "نقل",
      title: "نقل شقة غرفتين في إيمسبوتل — في نفس اليوم مع التنظيف النهائي",
      summary: "احتاجت عائلة ك. مساعدة عاجلة يوم الجمعة مساءً لنقل يوم السبت، مع تسليم المفاتيح (والتأمين على المحك) يوم الإثنين. أنجزنا نقل الأثاث والإخلاء والتنظيف النهائي في يوم واحد.",
      stats: { label1: "المدة", value1: "6 ساعات", label2: "المساحة", value2: "62 م²", label3: "الفريق", value3: "3 أشخاص" },
      price_eur: 1290,
      location: "هامبورغ-إيمسبوتل",
      services_included: ["نقل أثاث", "تغليف", "إخلاء قبو", "تنظيف نهائي"],
      challenge: "إشعار قصير جداً (24 ساعة)، الطابق الرابع بلا مصعد، تسليم يوم الإثنين والتأمين معرّض للضياع.",
      solution: "شغّلنا ثلاثة فرق بالتوازي: اثنان للحمل والتغليف، وواحد للتنظيف. وضعنا الأثاث بشكل ذكي في الشاحنة لتقليل الرحلات.",
      outcome: "تم تسليم المفاتيح في الوقت المحدد الإثنين الساعة 10:00، استُرد التأمين كاملاً. تجنّبت العائلة ضغوط نقل في عطلة نهاية الأسبوع بمفردها وتفرّغت لاستقرارها في الشقة الجديدة.",
      quote: "«ما كنا لنستطيع وحدنا. ثلاثة محترفين، يوم واحد، كل شيء منجز — حتى التنظيف النهائي. نوصي بتالكاني لكل أصدقائنا في هامبورغ.»",
      quote_author: "عائلة ك.، إيمسبوتل",
      image: "/generated/case_umzug_eimsbuettel.png",
      tag: "خدمة سريعة"
    },
    {
      id: "cs2",
      slug: "tanzif-mizrab-volksdorf",
      service: "regenrinne_reinigung",
      service_label: "تنظيف المزاريب",
      title: "مزراب مسدود في بيت مزدوج — مع توثيق بالكاميرا",
      summary: "بعد ثلاثة أسابيع من المطر المتواصل، عانى الزبون من ضرر مياه في الواجهة. كشفت كاميرا الأنابيب فوراً عن عش طيور يسدّ ماسورة التصريف.",
      stats: { label1: "المدة", value1: "2.5 ساعة", label2: "الارتفاع", value2: "9 م", label3: "التوثيق", value3: "كامل" },
      price_eur: 389,
      location: "هامبورغ-فولكسدورف",
      services_included: ["تنظيف مزراب", "فحص بكاميرا الأنابيب", "غسل ماسورة التصريف", "توثيق فيديو"],
      challenge: "كان الماء ينحدر على الواجهة منذ أسابيع. التأمين طلب دليلاً على إزالة السبب باحترافية.",
      solution: "تنظيف كامل بضغط عالٍ، ثم فحص بدقة 4K بكاميرا الأنابيب. تقرير فيديو وصور للتأمين.",
      outcome: "قبل التأمين التقرير دون استفسارات. تم تعويض الضرر اللاحق على الجدران والواجهة بالكامل — لم يدفع الزبون يورو واحداً من جيبه.",
      quote: "«محترفون بأدوات صحيحة. توثيق الفيديو كان لا يُقدّر بثمن — دفع التأمين فوراً.»",
      quote_author: "السيد س.، فولكسدورف",
      image: "/generated/case_regenrinne_volksdorf.png",
      tag: "مع توثيق فيديو"
    },
    {
      id: "cs3",
      slug: "tanzif-maktab-altona-shahri",
      service: "reinigung",
      service_label: "تنظيف مكاتب",
      title: "تنظيف مكتب شهري لوكالة في ألتونا",
      summary: "احتاجت وكالة رقمية في هامبورغ (12 موظفاً) شريك تنظيف للصيانة الدورية — الإثنين/الأربعاء/الجمعة، ساعتان لكل زيارة، قبل ساعات العمل.",
      stats: { label1: "التكرار", value1: "3×/أسبوع", label2: "المدة", value2: "ساعتان", label3: "الفترة", value3: "14 شهراً+" },
      price_eur: 690,
      price_unit: "/ شهر",
      location: "هامبورغ-ألتونا",
      services_included: ["تنظيف مكاتب", "تنظيف صحي", "تخلص من النفايات", "تنظيف زجاج ومرايا", "مطبخ صغير"],
      challenge: "يجب الانتهاء قبل الساعة 9 صباحاً، مطلوب وصول بالمفاتيح، معايير نظافة عالية (اجتماعات عملاء من 10 صباحاً).",
      solution: "فريق ثابت من شخصين، مفتاح مخصّص مع بروتوكول خدمة المفاتيح، قائمة تحقق لكل زيارة تُؤكّد بالصور.",
      outcome: "زبون منتظم منذ 14 شهراً، صفر شكاوى، فاتورة شهرية مع ضريبة القيمة المضافة — قابلة للخصم بالكامل كمصاريف تشغيلية.",
      quote: "«ننسى غالباً أنهم كانوا هنا — وهذا بالضبط الإطراء الذي تستحقه خدمة التنظيف.»",
      quote_author: "المدير العام، وكالة رقمية في ألتونا",
      image: "/generated/case_office_altona.png",
      tag: "عقد طويل الأمد"
    },
    {
      id: "cs4",
      slug: "qitaghiar-lkq-pv-hamburg",
      service: "autoteile",
      service_label: "لوجستيات قطع الغيار",
      title: "توزيع قطع الغيار لصالح LKQ و PV Automotive — أكثر من 300 توصيلة شهرياً",
      summary: "لصالح موزّعي قطع غيار السيارات ننفّذ يومياً رحلات توصيل إلى ورش السيارات في هامبورغ وشمال ألمانيا. قطع الغيار للإصلاحات الجارية يجب أن تصل إلى الورشة خلال أقل من 60 دقيقة — وإلا فسيبقى الزبون بدون سيارته.",
      stats: { label1: "التوصيلات", value1: "+300 شهرياً", label2: "زمن الإكسبريس", value2: "≤ 45 دقيقة", label3: "الورش", value3: "6 عملاء نشطين" },
      price_eur: null,
      price_unit: "تسعير تعاقدي",
      location: "هامبورغ والمنطقة المحيطة",
      services_included: ["توصيل للورش", "شحن إكسبريس", "توثيق بالصور", "إثبات GPS", "فاتورة موحدة"],
      challenge: "الورش تحجز مواعيد الإصلاح كل 30 دقيقة. إذا وصلت القطعة الخطأ أو تأخرت، ينهار الجدول ويؤجَّل عدة زبائن.",
      solution: "خطوط توصيل صباحية ومسائية ثابتة بمواعيد مخصصة لكل ورشة، مع سائق إكسبريس تحت الطلب للحالات العاجلة. كل تسليم يُوثَّق بصورة + ختم زمني GPS.",
      outcome: "بعد 12 شهراً من التعاون: 100% إثبات تسليم بالصور، متوسط 42 دقيقة من الطلب إلى تسليم الورشة، فاتورة شهرية موحدة متوافقة مع محاسبة DATEV.",
      quote: "«تالكاني هي عملياً قسمنا اللوجستي الممتد. عند الطوارئ، هم موجودون — مع دليل موثّق.»",
      quote_author: "مدير اللوجستيات، موزّع قطع غيار هامبورغ",
      image: "/generated/autoteile_handover.png",
      tag: "B2B · عمليات يومية"
    },
    {
      id: "cs5",
      slug: "khidmat-escooter-laylia-tier-dott",
      service: "escooter_service",
      service_label: "خدمة السكوترات الليلية",
      title: "خدمة السكوترات الكهربائية الليلية لـ TIER و Dott — حتى 400 مركبة/ليلة",
      summary: "لصالح شركات التنقل المشترك ننفّذ خدمة الشحن وإعادة التوزيع الليلية: جمع، شحن، توزيع — لتكون الأسطول جاهزاً صباحاً في المناطق ذات الطلب العالي.",
      stats: { label1: "سكوترات/ليلة", value1: "250–400", label2: "الوردية الليلية", value2: "22:00–06:00", label3: "المناطق", value3: "4 أحياء" },
      price_eur: null,
      price_unit: "تسعير تعاقدي",
      location: "ألتونا · إيمسبوتل · وسط المدينة · HafenCity",
      services_included: ["جمع السكوترات المعطلة", "استبدال البطاريات", "التنظيف والفحص", "إعادة التوزيع في المناطق المزدحمة", "تقارير جرد"],
      challenge: "الركاب يتوقعون توفر السكوترات من الساعة 07:00 في وسط المدينة والمحطات والأحياء الجامعية. ليلاً تتشتّت المركبات في المناطق السكنية — بدون إعادة توزيع تنخفض الإتاحة بنسبة تصل إلى 60%.",
      solution: "خمس شاحنات Sprinter تعمل ليلاً بربط مباشر مع التطبيق: مسارات آلية تعطي الأولوية للبطاريات الأدنى شحناً، جمع في مستودع الشحن، توزيع صباحي حسب خريطة الطلب الحرارية للمشغّل.",
      outcome: "متوسط 98% من الأسطول جاهز عند 07:00 في المناطق المستهدفة. أعطال البطاريات أقل من 1%. التوسع إلى بريمن وكيل قيد التخطيط.",
      quote: "«شريك عمليات موثوق. لا نراهم ليلاً — نرى النتيجة في التطبيق صباحاً.»",
      quote_author: "مدير عمليات الأسطول، شركة تنقل مشترك",
      image: "/generated/escooter.png",
      tag: "B2B · وردية ليلية"
    }
  ]
};
